// extracted by mini-css-extract-plugin
module.exports = {"container":"pages-not-found-container","title":"pages-not-found-title"};